import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { Sparkles, Instagram, Facebook, Twitter } from 'lucide-react';

export const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-charcoal text-white py-16" data-testid="footer">
      <div className="container-app">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-xl bg-accent flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-accent-foreground" />
              </div>
              <span className="font-heading text-2xl font-bold">AFY</span>
            </Link>
            <p className="text-white/60 text-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
            <div className="flex gap-4 mt-6">
              <a href="https://www.instagram.com/aaaallforyou?igsh=OWh6MXRtYWFveGMw" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-accent transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-white/60 hover:text-accent transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-white/60 hover:text-accent transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold mb-4">{t('footer.navigation')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/providers" className="text-white/60 hover:text-white transition-colors text-sm">
                  {t('nav.providers')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/60 hover:text-white transition-colors text-sm">
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link to="/register?role=provider" className="text-white/60 hover:text-white transition-colors text-sm">
                  {t('nav.becomeProvider')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-heading font-semibold mb-4">{t('footer.support')}</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-white/60 hover:text-white transition-colors text-sm">
                  {t('footer.faq')}
                </a>
              </li>
              <li>
                <a href="#" className="text-white/60 hover:text-white transition-colors text-sm">
                  {t('footer.contact')}
                </a>
              </li>
              <li>
                <a href="#" className="text-white/60 hover:text-white transition-colors text-sm">
                  {t('footer.privacy')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold mb-4">{t('footer.contact')}</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li>Hamburg, Germany</li>
              <li>contact@afy-services.com</li>
              <li>+49 40 123 456 789</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center text-sm text-white/40">
          <p>© {new Date().getFullYear()} AFY - All For You. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
